import { render, staticRenderFns } from "./yingjiao.vue?vue&type=template&id=22e8198f"
import script from "./yingjiao.vue?vue&type=script&lang=js"
export * from "./yingjiao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports